<template>
  <div>
    <div class="row mb-3">
      <div class="col-12">
        <div class="d-flex justify-content-between align-items-center">
          <p class="lead m-0">Novo lançamento</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="d-flex justify-content-center">
          <div class="w-50 mt-3">
            <form @submit="save" enctype="multipart/form-data">
              <template v-if="true">
                <div class="form-group">
                  <label>Setor</label>
                  <AutoComplete
                    v-model="confined_space.company_sector.name"
                    :dropdown="true"
                    :suggestions="filtered_company_sectors"
                    field="name"
                    class="w-100"
                    @complete="filterCompanySectors($event)"
                    @item-select="onCompanySectorSelect($event)"
                  />
                </div>

                <div class="form-group">
                  <label>Área</label>
                  <AutoComplete
                    v-model="confined_space.company_area.name"
                    :dropdown="true"
                    :suggestions="filtered_company_areas"
                    field="name"
                    class="w-100"
                    @complete="filterCompanyAreas($event)"
                    @item-select="onCompanyAreaSelect($event)"
                  />
                </div>

                <div class="form-group">
                  <label>Complemento</label>
                  <AutoComplete
                    v-model="confined_space.company_complement.name"
                    :dropdown="true"
                    :suggestions="filtered_company_complements"
                    field="name"
                    class="w-100"
                    @complete="filterCompanyComplements($event)"
                    @item-select="onCompanyComplementSelect($event)"
                  />
                </div>

                <div class="form-group">
                  <label>Tipo do espaço confinado</label>
                  <AutoComplete
                    v-model="confined_space.confined_space_type_id"
                    :dropdown="true"
                    :suggestions="filtered_confined_space_types"
                    field="name"
                    class="w-100"
                    @complete="filterConfinedSpaceTypes($event)"
                    @item-select="onConfinedSpaceTypeSelect($event)"
                  />
                </div>

                <div class="form-group">
                  <label>Nome do espaço confinado</label>
                  <input
                    type="text"
                    v-model="confined_space.name"
                    class="form-control"
                  />
                </div>

                <div class="form-group">
                  <label>Tag AMBRA</label>
                  <input
                    type="text"
                    v-model="confined_space.ambra_tag"
                    class="form-control"
                  />
                </div>

                <div class="form-group">
                  <label>Tag do espaço confinado</label>
                  <input
                    type="text"
                    v-model="confined_space.confined_space_tag"
                    class="form-control"
                  />
                </div>

                <div class="form-group">
                  <label>Foto do espaço confinado</label>
                  <input
                    type="file"
                    class="form-control-file"
                    name="picture"
                    @change="onPictureSelect"
                  />
                </div>

                <div class="form-group">
                  <label>Foto da Tag Ambra</label>
                  <input
                    type="file"
                    class="form-control-file"
                    name="ambra_tag_picture"
                    @change="onAmbraTagPictureSelect"
                  />
                </div>

                <div class="form-group">
                  <label class="form-check-label">
                    E.C. Está COMPLETAMENTE adequado em campo?
                  </label>
                  <div class="d-flex" style="max-width: 500px">
                    <div class="form-check form-check-inline">
                      <button
                        v-on:click="setButton('is_completely_suitable', 1, $event)"
                        class="form-button form-button-yes mr-3"
                        v-bind:class="{ 'border-active': confined_space.is_completely_suitable }"
                      >
                        <label class="form-check-label">
                          Sim
                        </label>
                      </button>
                    </div>
                    <div class="form-check form-check-inline">
                      <button
                        v-on:click="setButton('is_completely_suitable', 0, $event)"
                        class="form-button form-button-no mr-3"
                        v-bind:class="{ 'border-active': !confined_space.is_completely_suitable }"
                      >
                        <label class="form-check-label">
                          Não
                        </label>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label class="form-check-label">
                    E.C. possui FICHA TÉCNICA?
                  </label>
                  <div class="d-flex" style="max-width: 500px">
                    <div class="form-check form-check-inline">
                      <button
                        v-on:click="setButton('has_datasheet', 1, $event)"
                        class="form-button form-button-yes mr-3"
                        v-bind:class="{ 'border-active': confined_space.has_datasheet }"
                      >
                        <label class="form-check-label">
                          Sim
                        </label>
                      </button>
                    </div>
                    <div class="form-check form-check-inline">
                      <button
                        v-on:click="hasNotDatasheetClick($event)"
                        class="form-button form-button-no mr-3"
                        v-bind:class="{ 'border-active': !confined_space.has_datasheet }"
                      >
                        <label class="form-check-label">
                          Não
                        </label>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="form-group" v-if="confined_space.has_datasheet">
                  <label class="form-check-label">
                    Ficha Técnica do E.C. está ATUALIZADA?
                  </label>
                  <div class="d-flex" style="max-width: 500px">
                    <div class="form-check form-check-inline">
                      <button
                        v-on:click="setButton('is_datasheet_updated', 1, $event)"
                        class="form-button form-button-yes mr-3"
                        v-bind:class="{ 'border-active': confined_space.is_datasheet_updated }"
                      >
                        <label class="form-check-label">
                          Sim
                        </label>
                      </button>
                    </div>
                    <div class="form-check form-check-inline">
                      <button
                        v-on:click="setButton('is_datasheet_updated', 0, $event)"
                        class="form-button form-button-no mr-3"
                        v-bind:class="{ 'border-active': !confined_space.is_datasheet_updated }"
                      >
                        <label class="form-check-label">
                          Não
                        </label>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="confined_space.assign_work_fronts"
                      :value="0"
                      id="assign-work-fronts"
                    />
                    <label class="form-check-label" for="assign-work-fronts">
                      Atribuir frentes de trabalho
                    </label>
                  </div>
                </div>
                
                <button class="btn btn-dark">{{ submit_text }}</button>
              </template>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { useStore } from 'vuex'

  import AutoComplete from 'primevue/autocomplete'

  import useCompanyAreas from '@/modules/CompanyArea.js'
  import useCompanyComplements from '@/modules/CompanyComplement.js'
  import useCompanySectors from '@/modules/CompanySector.js'
  import useConfinedSpaceTypes from '@/modules/ConfinedSpaceType.js'

  import useSwal from '../../modules/Swal'
  import Swal from 'sweetalert2/src/sweetalert2.js'

  export default {
    components: {
      AutoComplete,
    },
    setup() {
      const route = useRoute()
      const store = useStore()
      const company = computed(() => store.getters.selected_company)
      const order_of_service = computed(() => store.getters.selected_order_of_service)

      const { company_areas, listCompanyAreasBySector } = useCompanyAreas()
      const { company_complements, listCompanyComplementsByArea } =
        useCompanyComplements()
      const { company_sectors, listCompanySectors } = useCompanySectors()
      const { confined_space_types, listConfinedSpaceTypes } = useConfinedSpaceTypes()
      const { showSuccessDialog, showErrorDialog, showAjaxDialog } = useSwal()

      listCompanySectors(company.value?.id)
      listConfinedSpaceTypes()

      const isEditing = route.params.id ? true : false

      return {
        company,
        order_of_service,
        company_areas,
        company_complements,
        company_sectors,
        confined_space_types,
        listCompanyAreasBySector,
        listCompanyComplementsByArea,
        listConfinedSpaceTypes,
        showErrorDialog,
        showSuccessDialog,
        showAjaxDialog,
        isEditing,
      }
    },
    data() {
      return {
        confined_space: {
          id: null,
          company_id: null,
          order_of_service_id: null,
          confined_space_type_id: null,
          company_sector: {
            name: '',
          },
          company_area: {
            name: '',
          },
          company_complement: {
            name: '',
          },
          name: '',
          ambra_tag: '',
          confined_space_tag: '',
          picture: '',
          ambra_tag_picture: '',
          is_completely_suitable: 0,
          has_datasheet: 0,
          is_datasheet_updated: 0,
          assign_work_fronts: 0,
        },
        filtered_company_class: [],
        filtered_confined_space_types: [],
        filtered_company_areas: [],
        filtered_company_complements: [],
        filtered_company_sectors: [],
        submit_text: '',
      }
    },
    mounted() {
      const app = this

      if (app.isEditing) {
        const id = app.$route.params.id
        app.getConfinedSpaceData(id)
        app.submit_text = 'Salvar alterações'
      } else {
        app.submit_text = 'Cadastrar'
      }
    },
    methods: {
      async getConfinedSpaceData(id) {
        const app = this

        const data = await app.axios.get(`/api/confined_spaces/get/${id}`)
          .then(({data}) => data.data)
          .catch(error => {
            console.log(error)
            return null
          })

        if (!data) return

        app.confined_space.id = data.id
        app.confined_space.order_of_service_id = data.order_of_service_id
        app.confined_space.company_id = data.company_id
        app.confined_space.confined_space_type_id = data.confined_space_type_id
        app.confined_space.company_sector.name = data.company_sector.name
        app.confined_space.company_area.name = data.company_area.name
        app.confined_space.company_complement.name = data.company_complement.name
        app.confined_space.name = data.name
        app.confined_space.ambra_tag = data.ambra_tag
        app.confined_space.confined_space_tag = data.confined_space_tag
        app.confined_space.picture = data.picture_url
        app.confined_space.ambra_tag_picture = data.ambra_tag_picture_url
        
        app.confined_space.is_completely_suitable = data.is_completely_suitable ? 1 : 0
        app.confined_space.has_datasheet = data.has_datasheet ? 1 : 0
        app.confined_space.is_datasheet_updated = data.is_datasheet_updated ? 1 : 0
      },

      filterCompanyAreas(event) {
        setTimeout(() => {
          if (!event.query.trim().length) {
            this.filtered_company_areas = [...this.company_areas]
          } else {
            this.filtered_company_areas = this.company_areas.filter(
              (company_area) => {
                return company_area.name
                  .toLowerCase()
                  .startsWith(event.query.toLowerCase())
              },
            )
          }
        }, 250)
      },

      filterCompanyComplements(event) {
        setTimeout(() => {
          if (!event.query.trim().length) {
            this.filtered_company_complements = [...this.company_complements]
          } else {
            this.filtered_company_complements = this.company_complements.filter(
              (company_complement) => {
                return company_complement.name
                  .toLowerCase()
                  .startsWith(event.query.toLowerCase())
              },
            )
          }
        }, 250)
      },

      filterCompanySectors(event) {
        setTimeout(() => {
          if (!event.query.trim().length) {
            this.filtered_company_sectors = [...this.company_sectors]
          } else {
            this.filtered_company_sectors = this.company_sectors.filter(
              (company_sector) => {
                return company_sector.name
                  .toLowerCase()
                  .startsWith(event.query.toLowerCase())
              },
            )
          }
        }, 250)
      },

      filterConfinedSpaceTypes(event) {
        setTimeout(() => {
          if (!event.query.trim().length) {
            this.filtered_confined_space_types = [...this.confined_space_types]
          } else {
            this.filtered_confined_space_types = this.confined_space_types.filter(
              (confined_space_type) => {
                return confined_space_type.name
                  .toLowerCase()
                  .startsWith(event.query.toLowerCase())
              }
            )
          }
        }, 250)
      },

      onCompanyAreaSelect(event) {
        this.confined_space.company_area.name =
          event.value.name.toLocaleUpperCase('pt-BR')
        this.listCompanyComplementsByArea(event.value.id)
      },

      onCompanyComplementSelect(event) {
        this.confined_space.company_complement.name =
          event.value.name.toLocaleUpperCase('pt-BR')
      },

      onCompanySectorSelect(event) {
        this.confined_space.company_sector.name =
          event.value.name.toLocaleUpperCase('pt-BR')
        this.listCompanyAreasBySector(event.value.id)
      },

      onConfinedSpaceTypeSelect(event) {
        this.confined_space.confined_space_type =
          event.value.name.toLocaleUpperCase('pt-BR')
      },

      onAmbraTagPictureSelect(event) {
        this.confined_space.ambra_tag_picture = event.target.files[0]
      },

      onPictureSelect(event) {
        this.confined_space.picture = event.target.files[0]
      },

      hasNotDatasheetClick(event) {
        this.setButton('has_datasheet', 0, event)
        this.setButton('is_datasheet_updated', 0, event)
      },

      setButton(button, value, event) {
        if (event) event.preventDefault()
        this.confined_space[button] = value
      },

      toggleButton(value, event) {
        if (event) event.preventDefault()

        if (this.confined_space[value]) this.confined_space[value] = 0
        else this.confined_space[value] = 1
      },

      save(event) {
        event.preventDefault()
        const app = this

        const url = `/api/confined_spaces/`

        let request = {
          url: url + (app.isEditing ? 'update' : 'store'),
          data: new FormData(),
          config: {
            headers: {
              'content-type': 'multipart/form-data',
            }
          }
        }

        request.data.append('id', app.confined_space.id)
        request.data.append('company_id', this.company.id)
        request.data.append('order_of_service_id', this.order_of_service.id)
        request.data.append(
          'confined_space_type_id',
          JSON.stringify(app.confined_space.confined_space_type_id)
        )
        request.data.append('company_sector[name]', app.confined_space.company_sector.name)
        request.data.append('company_area[name]', app.confined_space.company_area.name)
        request.data.append('company_complement[name]', app.confined_space.company_complement.name)
        request.data.append('name', app.confined_space.name)
        request.data.append('ambra_tag', app.confined_space.ambra_tag)
        request.data.append('confined_space_tag', app.confined_space.confined_space_tag)
        request.data.append('picture', app.confined_space.picture)
        request.data.append('ambra_tag_picture', app.confined_space.ambra_tag_picture)
        request.data.append('is_completely_suitable', app.confined_space.is_completely_suitable)
        request.data.append('has_datasheet', app.confined_space.has_datasheet)
        request.data.append('is_datasheet_updated', app.confined_space.is_datasheet_updated)
        request.data.append('assign_work_fronts', app.confined_space.assign_work_fronts)

        Swal.fire({
          title: 'Tem certeza desta operação?',
          text: 'Verifique todos os campos antes de efetuar o cadastro.',
          confirmButtonText: 'Cadastrar',
          cancelButtonText: 'Cancelar',
          showCancelButton: true,
          showLoaderOnConfirm: true,
          preConfirm: function () {
            return app.axios
              .post(request.url, request.data, request.config)
              .then(() => {
                app.showSuccessDialog()

                setTimeout(() => {
                  app.$router.go(-1)
                }, 500)
              })
              .catch(error => {
                let result = ''

                if (error && error.response.data) {
                  let container = document.createElement('div')

                  let paragraph = document.createElement('p')
                  if (error.response.data.message) {
                    paragraph.appendChild(
                      document.createTextNode(error.response.data.message),
                    )
                    paragraph.classList.add('alert')
                    paragraph.classList.add('alert-danger')
                  }

                  let list = document.createElement('ul')
                  for (let key in error.response.data.errors) {
                    let itemElement = document.createElement('li')
                    itemElement.appendChild(
                      document.createTextNode(error.response.data.errors[key]),
                    )
                    list.appendChild(itemElement)
                  }

                  container.appendChild(paragraph)
                  container.appendChild(list)
                  result = container
                }

                app.showErrorDialog(result)
              })
          }
        })
      }
    },
  }
</script>

<style lang="scss" scoped>
  .form-button {
    padding: 10px 50px;
    font-weight: bold;
    color: white;
    border: white solid 2px;
    border-radius: 4px;
    transition: 0.3s;
  }

  .form-button-yes {
    background-color: #5de466;
  }

  .form-button-no {
    background-color: #dd364a;
  }

  .border-active {
    transition: 0.3s;
    border: black solid 2px;
  }
</style>
